/* eslint-disable no-nested-ternary */
/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
import { Box, TableCell, TableRow } from "@mui/material";
import React, { useEffect, useMemo, useState, useContext } from "react";
import * as Sentry from "@sentry/react";
import { useNavigate } from "react-router-dom";
import WarningIcon from "@mui/icons-material/Warning";
import Modal from "../../../../components/common/Modal/Modal";
import GhostTable from "../../../../components/common/new/GhostTable/GhostTable";
import Pagination from "../../../../components/common/new/Pagination/Pagination";
import Table from "../../../../components/common/new/Table/Table";
import Typography from "../../../../components/common/new/Typography/Typography";
import { Constants, AlertStatus, PERMISSIONS } from "../../../../contants";
import {
  APPOINTMENT_COL,
  ATTENDANCE_COL,
  FAMILY_COL,
  SUBSCRIPTION_COL,
  GOHONZON_COL,
  INPROGRESS_APPOINTMENT_COL,
  PREVIOUS_APPOINTMENT_COL,
  PREVIOUS_APPOINTMENT_EXPAND_COL,
  // EXAMINATION_COL,
  AWARDS_COL,
  REMARKS_COL,
  SPECIAL_GROUP_COL,
  HDC_COL,
  APPOINTMENT_EXPAND_COL,
} from "../../../../contants/table/member";
import Member from "../../../../services/api/member";
import { performOperation } from "../../MemberSearch/utils";
import CardWithFooter from "../../components/CardWithFooter/CardWithFooter";
import {
  FLEX_CONTAINER,
  MAX_SIZE,
  ROW_LIMIT,
  TABLE_TYPE,
  getAppointmentRows,
  getAttendanceRows,
  getFamilyMemberRows,
  getFormattedAppointments,
  getFormattedAllPreviousAppointments,
  getFormattedData,
  getFormattedMembers,
  getMaxRow,
  getSubscriptionRows,
  getGohonzonMemberRows,
  getFormattedGohonzon,
  getPreviousAppointmentRows,
  getInprogressAppointmentRows,
  getFormattedSubscription,
  getAllPreviousAppointmentRows,
  ATTENDANCE_MAX_SIZE,
  getAllFamilyMemberRows,
  getExamRows,
  getAwardRows,
  getFormattedExam,
  getFormattedAward,
  getSpecialGroupRows,
  getFormattedSpecial,
  getHdcRows,
  getFormattedHdc,
  getAllAppointmentRows,
} from "../utlis";
import styles from "./Dashboard.styles";
import UnderProgress from "../../components/UnderProgress/UnderProgess";
import { ROUTES } from "../../../../utils/constants";
import NewTable from "../../components/Newtable/NewTable";
import Notes from "../../../../assets/svg/Notes";
import Awards from "../../../../assets/svg/Awards";
import Comment from "../../../../assets/svg/Comment";
import Dropdown from "../../../../components/common/new/Dropdown/Dropdown";
import GreenFlag from "../../../../assets/svg/GreenFlag";
import YellowFlag from "../../../../assets/svg/YellowFlag";
import Family from "../../../../services/api/Family";
import Loader from "../../../../components/common/Loader/Loader";
import DirectEntryModal from "../../../gohonzon/DirectEntry/DirectEntryModal";
import EditSubscription from "../Components/EditSubscription";
import DirectExamEntryModal from "../Components/DirectExamEntry/DirectExamEntryModal";
import PaginationForMobile from "../../../../components/common/new/Pagination/PaginationForMobile";
import useUserConfig from "../../../../hooks/useUserConfig";
import { ToastAlertContext } from "../../../../config/providers/ToastAlert";
import UpdateDirectExamEntryModal from "../Components/DirectExamEntry/UpdateDirectExamEntryModal";
import Button from "../../../../components/common/Button";

const ALERT_DATA = [
  {
    message: "New Changes in Profile",
    date: "01/01/1970",
  },
  {
    message: "New Changes in Family",
    date: "01/01/1970",
  },
];

const ENTRANCE_DATA = [
  {
    exam: "ENTERANCE",
    date: "January, 1970",
  },
  {
    exam: "INTRODUCTORY",
    date: "January, 1970",
  },
  {
    exam: "INTERMEDIATE",
    date: "January, 1970",
  },
  {
    exam: "ADVANCE",
    date: "January, 1970",
  },
];

const MEETING_TYPE = [
  {
    value: "discussionMeeting",
    key: "Discussion Meeting",
  },
  {
    value: "goshoMeeting",
    key: "Gosho Meeting",
  },
  {
    value: "NHRMeeting",
    key: "NHR Meeting",
  },
  {
    value: "cubMeeting",
    key: "Cub Meeting",
  },
  {
    value: "YPMeeting",
    key: "Young Pheonix Meeting",
  },
  {
    value: "YLMeeting",
    key: "Young Lion Meeting",
  },
  {
    value: "SDMeeting",
    key: "Student Meeting",
  },
];

function AttendanceTabel({ meeting, table1, table2 }) {
  return (
    <Box style={styles.attandenceTable}>
      <Typography
        component="p"
        weight={600}
        mb={4}
        style={{ color: "#607E9F", fontSize: "14px" }}
      >
        {meeting?.title}
      </Typography>
      <NewTable
        columns={ATTENDANCE_COL}
        tableHeadCellStyle={{
          ...styles.tableHeadCells,
        }}
        rows={getAttendanceRows(meeting?.rows)}
        tableBodyTheme="#FFFFFF"
      />
    </Box>
  );
}

const getAlertContent = (data) => (
  <Box style={styles.listContainer}>
    {data.map((item) => (
      <Box style={styles.item}>
        <Typography style={{ color: "#000000", fontSize: " 14px" }}>
          • {item.message}
        </Typography>
        <Typography
          weight={600}
          style={{ color: "#000000", fontSize: " 12px" }}
        >
          {item.date}
        </Typography>
      </Box>
    ))}
  </Box>
);

const getContent = (data, limit = ROW_LIMIT.EXAMINATION) =>
  data?.slice(0, limit)?.map((item) => {
    return (
      <TableRow>
        <TableCell align="left" width="20%" style={styles.tableRowCell}>
          <Typography variant="mini" color="#000000">
            {item.exam}
          </Typography>
        </TableCell>
        <TableCell align="center" width="20%" style={styles.tableRowCell}>
          <Typography variant="mini" color="#000000">
            {item.date}
          </Typography>
        </TableCell>
      </TableRow>
    );
  });

const getApi = (tableType) => {
  switch (tableType) {
    case TABLE_TYPE.FAMILY:
      return Family.getFamilyDetailsByMemberId;
    case TABLE_TYPE.APPOINTMENT:
      return Member.getCurrentAppointmentsByMemberId;
    case TABLE_TYPE.ATTENDANCE:
      return Member.getAttendanceByMemberId;
    case TABLE_TYPE.GOHONZON:
      return Member.getMemberDetailsById;
    case TABLE_TYPE.PREVIOUSAPPOINTMENT:
      return Member.getAppointmentsByMemberId;
    case TABLE_TYPE.INPROGRESSAPPOINTMENT:
      return Member.getMemberDetailsById;
    case TABLE_TYPE.EXAMINATION:
      return Member.getExamByMemberId;
    case TABLE_TYPE.SUBS:
      return Member.getSubscriptionByMemberId;
    case TABLE_TYPE.AWARDS:
      return Member.getAwardByMemberId;
    case TABLE_TYPE.SPECIAL:
      return Member.getMemberDetailsById;
    case TABLE_TYPE.HDC:
      return Member.getMemberDetailsById;
    default:
      return null;
  }
};

const getBeautifyData = (data, selectedTable) => {
  if (selectedTable === TABLE_TYPE.APPOINTMENT) {
    return getFormattedAppointments(data);
  }
  if (selectedTable === TABLE_TYPE.PREVIOUSAPPOINTMENT) {
    return getFormattedAllPreviousAppointments(data);
  }
  if (selectedTable === TABLE_TYPE.ATTENDANCE) {
    return getFormattedData(data);
  }
  if (selectedTable === TABLE_TYPE.GOHONZON) {
    return getFormattedGohonzon(data);
  }
  if (selectedTable === TABLE_TYPE.SUBS) {
    return getFormattedSubscription(data);
  }
  if (selectedTable === TABLE_TYPE.EXAMINATION) {
    return getFormattedExam(data);
  }
  if (selectedTable === TABLE_TYPE.AWARDS) {
    return getFormattedAward(data);
  }
  if (selectedTable === TABLE_TYPE.SPECIAL) {
    return getFormattedSpecial(data);
  }
  if (selectedTable === TABLE_TYPE.HDC) {
    return getFormattedHdc(data);
  }
  return getFormattedMembers(data);
};

function Alert({ open, onClose, onSubmit, selectedMember }) {
  const handleSubmit = () => {
    onSubmit(selectedMember);
    onClose();
  };

  return (
    <Box>
      <Modal open={open} onClose={onClose}>
        <Typography
          style={{ fontSize: "20px", fontWeight: "500", paddingBottom: "20px" }}
        >
          Are you sure you want to
          <br />
          delete this entry?
        </Typography>
        <Box
          style={{
            paddingTop: "50px",
            display: "flex",
            justifyContent: "center",
          }}
        >
          <Button
            onClick={handleSubmit}
            label="Yes"
            style={{ marginRight: "10px" }}
          />
          <Button onClick={onClose} label="No" variant="outlined" />
        </Box>
      </Modal>
    </Box>
  );
}

function ModalContent({
  memberId,
  modalTitle,
  selectedTable,
  subTitle,
  meetingType,
  meetingType1,
  meetingType2,
  onRefresh,
}) {
  const [tableData, setTableData] = useState([]);
  const [paginationInfo, setPaginationInfo] = useState({});
  const [familyTableData, setFamilyTableData] = useState([]);
  const [isAppointmentLoading, setIsAppoitmentLoading] = useState(false);
  const hasPermission = useUserConfig();
  const toast = useContext(ToastAlertContext);
  const [updateExamEntryModal, setUpdateExamEntryModal] = useState(false);
  const [selectedExam, setSelectedExam] = useState(null);
  const [openAlert, setOpenAlert] = useState(false);
  const [selectedMember, setSelectedMember] = useState(null);

  const toggleAlert = () => {
    setOpenAlert(false);
  };

  const toggleUpdateExamEntry = (exam = null) => {
    setSelectedExam(exam);
    setUpdateExamEntryModal((prev) => !prev);
  };

  const EXAMINATION_COL = [
    {
      displayName: "Exam Name",
      key: "exam",
    },
    {
      displayName: "Exam Month",
      key: "examMonth",
    },
    {
      displayName: "Exam Year",
      key: "examYear",
    },
    ...(hasPermission(PERMISSIONS.REMOVE_EXAMINATION_APPLIED_MEMBERS) ||
    hasPermission(PERMISSIONS.UPDATE_EXAMINATION_APPLIED_MEMBERS)
      ? [
          {
            displayName: "Action",
            key: "action",
          },
        ]
      : []),
  ];

  const onEditClick = (exam) => {
    toggleUpdateExamEntry(exam);
  };

  const onDeleteClick = async () => {
    try {
      const payload = {
        examDate: selectedMember.examDate,
        examLevel: selectedMember.examLevel?.toUpperCase(),
        rollNumber: selectedMember.rollNumber,
        remark: selectedMember.remark,
      };
      await Member.removeExam({
        // applicationId: selectedMember.applicationId,
        applicationId: selectedMember.examId || selectedMember.applicationId,
        // memberId: selectedMember.memberId,
        memberId: selectedMember.memberId || memberId,
        data: payload,
      });
      toast.show(`Entry Removed Successfully`, AlertStatus.SUCCESS);
      setTimeout(() => {
        window.location.reload();
        onRefresh();
      }, 2000);
    } catch (error) {
      toast.show(error.message, AlertStatus.ERROR);
      Sentry.captureException(error);
    }
  };

  const handleDeleteClick = (member) => {
    setSelectedMember(member);
    setOpenAlert(true);
  };

  const fetchTableData = async (
    tableKey,
    page = 0,
    size = Constants.DEFAULT_PAGE_SIZE
  ) => {
    try {
      if (TABLE_TYPE.PREVIOUSAPPOINTMENT) {
        setIsAppoitmentLoading(true);
      }
      const { data } = await getApi(tableKey)(memberId, { page, size });

      setTableData(
        getBeautifyData(
          data.data ?? data.content ?? data.inductionSpecialGroups ?? data,
          tableKey
        )
      );
      setIsAppoitmentLoading(false);
      setFamilyTableData(getFormattedMembers(data?.familyMembers, tableKey));
      setPaginationInfo({
        currentPage: Number(data.number),
        totalPages: Number(data.totalPages),
        totalElements: Number(data.totalElements),
        pageSize: Number(data.size),
      });
    } catch (error) {
      Sentry.captureException(error);
    }
  };

  const content = useMemo(() => {
    if (selectedTable === TABLE_TYPE.APPOINTMENT) {
      return {
        rows: getAllAppointmentRows(tableData, MAX_SIZE, paginationInfo),
        columns: APPOINTMENT_EXPAND_COL,
      };
    }
    if (selectedTable === TABLE_TYPE.PREVIOUSAPPOINTMENT) {
      return {
        rows: getAllPreviousAppointmentRows(
          tableData,
          MAX_SIZE,
          paginationInfo
        ),
        columns: PREVIOUS_APPOINTMENT_EXPAND_COL,
      };
    }
    if (selectedTable === TABLE_TYPE.INPROGRESSAPPOINTMENT) {
      return {
        rows: getInprogressAppointmentRows(
          familyTableData,
          tableData,
          MAX_SIZE
        ),
        columns: INPROGRESS_APPOINTMENT_COL,
      };
    }
    if (selectedTable === TABLE_TYPE.FAMILY) {
      return {
        rows: getAllFamilyMemberRows(familyTableData, MAX_SIZE),
        columns: FAMILY_COL,
      };
    }
    if (selectedTable === TABLE_TYPE.GOHONZON) {
      return {
        rows: getGohonzonMemberRows(tableData, MAX_SIZE),
        columns: GOHONZON_COL,
      };
    }
    if (selectedTable === TABLE_TYPE.SUBS) {
      return {
        rows: getSubscriptionRows(tableData, MAX_SIZE),
        columns: SUBSCRIPTION_COL,
      };
    }
    if (selectedTable === TABLE_TYPE.EXAMINATION) {
      return {
        rows: getExamRows(
          tableData,
          hasPermission,
          handleDeleteClick,
          onEditClick,
          MAX_SIZE
        ),
        columns: EXAMINATION_COL,
      };
    }
    if (selectedTable === TABLE_TYPE.AWARDS) {
      return {
        rows: getAwardRows(tableData, MAX_SIZE),
        columns: AWARDS_COL,
      };
    }
    if (selectedTable === TABLE_TYPE.ATTENDANCE) {
      return {
        rows: getAttendanceRows(tableData, ATTENDANCE_MAX_SIZE),
        columns: ATTENDANCE_COL,
      };
    }
    if (selectedTable === TABLE_TYPE.SPECIAL) {
      return {
        rows: getSpecialGroupRows(tableData, MAX_SIZE),
        columns: SPECIAL_GROUP_COL,
      };
    }
    if (selectedTable === TABLE_TYPE.HDC) {
      return {
        rows: getHdcRows(tableData, MAX_SIZE),
        columns: HDC_COL,
      };
    }
    return {
      rows: [],
      columns: SUBSCRIPTION_COL,
    };
  }, [tableData, selectedTable]);

  const onPaginationClick = (page) => {
    const { pageSize } = paginationInfo;
    fetchTableData(selectedTable, page, pageSize);
  };

  const onPageSizeClick = (operator) => {
    const { pageSize } = paginationInfo;
    const newPageSize = performOperation(
      pageSize,
      Constants.DEFAULT_PAGE_SIZE,
      operator
    );
    fetchTableData(selectedTable, 0, newPageSize);
  };

  useEffect(() => {
    if (selectedTable) {
      fetchTableData(selectedTable);
    }
  }, [selectedTable]);

  return (
    <>
      {isAppointmentLoading && <Loader />}

      {/* <Box style={{ maxHeight: '400px', overflow: 'auto' }}> */}
      <Typography
        component="p"
        weight={600}
        mb={4}
        fontSize="16px"
        color="#000000"
      >
        {modalTitle || subTitle}
      </Typography>
      {FLEX_CONTAINER.includes(selectedTable) ? (
        <Box display="flex" gap="1rem">
          <AttendanceTabel
            meeting={
              meetingType === "goshoMeeting"
                ? tableData.goshoMeeting
                : meetingType === "NHRMeeting"
                ? tableData.NHRMeeting
                : meetingType === "cubMeeting"
                ? tableData.cubMeeting
                : meetingType === "SDMeeting"
                ? tableData.SDMeeting
                : meetingType2 === "YPMeeting"
                ? tableData.YPMeeting
                : meetingType2 === "YLMeeting"
                ? tableData.YLMeeting
                : tableData.discussionMeeting
            }
            table1
          />
          <AttendanceTabel
            meeting={
              meetingType1 === "discussionMeeting"
                ? tableData.discussionMeeting
                : meetingType1 === "NHRMeeting"
                ? tableData.NHRMeeting
                : meetingType1 === "cubMeeting"
                ? tableData.cubMeeting
                : meetingType1 === "SDMeeting"
                ? tableData.SDMeeting
                : meetingType2 === "YPMeeting"
                ? tableData.YPMeeting
                : meetingType2 === "YLMeeting"
                ? tableData.YLMeeting
                : tableData.goshoMeeting
            }
            table2
          />
          <AttendanceTabel
            meeting={
              meetingType2 === "goshoMeeting"
                ? tableData.goshoMeeting
                : meetingType2 === "NHRMeeting"
                ? tableData.NHRMeeting
                : meetingType2 === "cubMeeting"
                ? tableData.cubMeeting
                : meetingType2 === "SDMeeting"
                ? tableData.SDMeeting
                : meetingType2 === "YPMeeting"
                ? tableData.YPMeeting
                : meetingType2 === "YLMeeting"
                ? tableData.YLMeeting
                : tableData.discussionMeeting
            }
          />
        </Box>
      ) : (
        <NewTable
          columns={content.columns}
          columnCellStyle={{ padding: "8px" }}
          headCellStyle={{ fontSize: 12 }}
          rows={content.rows}
          tableHeadCellStyle={{ ...styles.tableHeadCells, height: "48px" }}
          scrollable
          tableBodyTheme="#F6F6F6"
        />
      )}
      <Box display="flex" justifyContent="center" mt={8}>
        {selectedTable !== TABLE_TYPE.FAMILY &&
          selectedTable !== TABLE_TYPE.SPECIAL &&
          selectedTable !== TABLE_TYPE.EXAMINATION &&
          selectedTable !== TABLE_TYPE.AWARDS &&
          selectedTable !== TABLE_TYPE.GOHONZON &&
          selectedTable !== TABLE_TYPE.SUBS && (
            <PaginationForMobile
              totalPages={paginationInfo.totalPages}
              totalResults={paginationInfo.totalElements}
              currentPage={paginationInfo.currentPage}
              pageSize={paginationInfo.pageSize}
              onChange={onPaginationClick}
              onPageSizeClick={onPageSizeClick}
            />
          )}
      </Box>
      <UpdateDirectExamEntryModal
        open={updateExamEntryModal}
        onClose={() => toggleUpdateExamEntry()}
        exam={selectedExam}
        onRefresh={onRefresh}
      />
      <Alert
        open={openAlert}
        onClose={toggleAlert}
        onSubmit={onDeleteClick}
        selectedMember={selectedMember}
      />
    </>
  );
}

function DashboardForMobile({
  memberId,
  familyMemberInfo,
  attendanceInfo,
  appointmentInfo,
  memberInfo,
  gohonzonMemberInfo,
  previousAppointmentInfo,
  subscriptionMemberInfo,
  inProgressAppointmentInfo,
  examMemberInfo,
  awardMemberInfo,
  specialMemberInfo,
  // setIsAttendanceLoading,
  // isAttendanceLoading,
  hdcInfo,
  onRefresh,
}) {
  const {
    remark,
    districtId,
    regionId,
    areaId,
    clusterId,
    zoneId,
    chapterId,
    subdivisionId,
  } = memberInfo;
  const [openModal, setOpenModal] = useState(false);
  const [selectedTable, setSelectedTable] = useState(null);
  const [modalTitle, setModalTitle] = useState("");
  const [modalSubTitle, setModalSubTitle] = useState("");
  const [meetingType, setMeetingType] = useState(
    subdivisionId !== null ? "cubMeeting" : "discussionMeeting"
  );
  const [meetingType1, setMeetingType1] = useState(
    subdivisionId !== null ? "YPMeeting" : "goshoMeeting"
  );
  const [meetingType2, setMeetingType2] = useState(
    subdivisionId !== null ? "YLMeeting" : "SDMeeting"
  );

  useEffect(() => {
    if (subdivisionId !== null) {
      setMeetingType("cubMeeting");
      setMeetingType1("YPMeeting");
      setMeetingType2("YLMeeting");
    } else {
      setMeetingType("discussionMeeting");
      setMeetingType1("goshoMeeting");
      setMeetingType2("SDMeeting");
    }
  }, [subdivisionId]);
  const [isHovered, setIsHovered] = React.useState(false);

  const handleMouseEnter = () => {
    setIsHovered(true);
  };

  const handleMouseLeave = () => {
    setIsHovered(false);
  };

  const gohonzonDetails = memberInfo?.familyGohonzons?.map((gohonzons) => {
    return gohonzons;
  });

  const {
    goshoMeeting,
    discussionMeeting,
    NHRMeeting,
    cubMeeting,
    SDMeeting,
    YLMeeting,
    YPMeeting,
  } = attendanceInfo;
  const navigate = useNavigate();
  const [directEntryModal, setDirectEntryModal] = useState(false);
  const [editSubscription, setEditSubscription] = useState(false);
  const [directExamEntryModal, setDirectExamEntryModal] = useState(false);
  const hasPermission = useUserConfig();
  const toast = useContext(ToastAlertContext);
  const [updateExamEntryModal, setUpdateExamEntryModal] = useState(false);
  const [selectedExam, setSelectedExam] = useState(null);

  const toggleUpdateExamEntry = (exam = null) => {
    setSelectedExam(exam);
    setUpdateExamEntryModal((prev) => !prev);
  };

  const EXAMINATION_COL = [
    {
      displayName: "Exam Name",
      key: "exam",
    },
    {
      displayName: "Exam Month",
      key: "examMonth",
    },
    {
      displayName: "Exam Year",
      key: "examYear",
    },
    ...(hasPermission(PERMISSIONS.REMOVE_EXAMINATION_APPLIED_MEMBERS) ||
    hasPermission(PERMISSIONS.UPDATE_EXAMINATION_APPLIED_MEMBERS)
      ? [
          {
            displayName: "Action",
            key: "action",
          },
        ]
      : []),
  ];

  const [openAlert, setOpenAlert] = useState(false);
  const [selectedMember, setSelectedMember] = useState(null);

  const toggleAlert = () => {
    setOpenAlert(false);
  };

  const onEditClick = (exam) => {
    toggleUpdateExamEntry(exam);
  };

  const onDeleteClick = async () => {
    try {
      const payload = {
        examDate: selectedMember.examDate,
        examLevel: selectedMember.examLevel?.toUpperCase(),
        rollNumber: selectedMember.rollNumber,
        remark: selectedMember.remark,
      };
      await Member.removeExam({
        // applicationId: selectedMember.applicationId,
        applicationId: selectedMember.examId || selectedMember.applicationId,
        // memberId: selectedMember.memberId,
        memberId: selectedMember.memberId || memberId,
        data: payload,
      });
      toast.show(`Entry Removed Successfully`, AlertStatus.SUCCESS);
      setTimeout(() => {
        onRefresh();
      }, 2000);
    } catch (error) {
      toast.show(error.message, AlertStatus.ERROR);
      Sentry.captureException(error);
    }
  };

  const handleDeleteClick = (member) => {
    setSelectedMember(member);
    setOpenAlert(true);
  };

  const toggleEditSub = () => {
    setEditSubscription((prev) => !prev);
  };

  const toggleDirectEntry = () => {
    setDirectEntryModal((prev) => !prev);
  };

  const toggleDirectExamEntry = () => {
    setDirectExamEntryModal((prev) => !prev);
  };

  const toggleModal = () => setOpenModal((prev) => !prev);

  const onViewMoreHandler = (tableType, title, subTitle) => {
    setModalTitle(title);
    setModalSubTitle(subTitle);
    setSelectedTable(tableType);
    toggleModal();
  };

  const onSelectMember = (member) => {
    navigate(`/${ROUTES.MEMBER_DETAIL.path}/${member.memberId}`);
  };

  // useEffect(() => {
  //   setTimeout(() => {
  //     setIsAttendanceLoading(false);
  //   }, 10000);
  // }, []);
  return (
    <>
      <Box style={styles.mainContainer}>
        <Box style={{ display: "flex" }}>
          <Box style={styles.main}>
            <Box
              style={{
                ...styles.cardContainerMobile,
                height: "750px",
              }}
            >
              <CardWithFooter
                onViewMoreHandler={onViewMoreHandler}
                title="Family Member Details"
                minHeight={100}
                tableType={TABLE_TYPE.FAMILY}
                disableViewMore={familyMemberInfo.length <= ROW_LIMIT.FAMILY}
                customStyles={{
                  width: "85vw",
                }}
                mainContainerStyle={{
                  padding: "10px",
                  flexDirection: "column",
                  alignItems: "flex-start",
                  minWidth: "247px",
                  marginTop: "20px",
                }}
                icon={
                  gohonzonDetails?.toString() === "OKATAKI_GOHONZON" ? (
                    <div style={styles.flagSvgStyle}>
                      <div
                        onMouseEnter={handleMouseEnter}
                        onMouseLeave={handleMouseLeave}
                      >
                        <GreenFlag />
                      </div>
                      {isHovered && (
                        <div style={styles.hoverStyle}>
                          {gohonzonDetails?.toString().split("_")[0]}
                        </div>
                      )}
                    </div>
                  ) : gohonzonDetails?.toString() === "OMAMORI_GOHONZON" ? (
                    <div style={styles.flagSvgStyle}>
                      <div
                        onMouseEnter={handleMouseEnter}
                        onMouseLeave={handleMouseLeave}
                      >
                        {" "}
                        <YellowFlag />
                      </div>
                      {isHovered && (
                        <div style={styles.hoverStyle}>
                          {gohonzonDetails?.toString().split("_")[0]}
                        </div>
                      )}
                    </div>
                  ) : null
                }
              >
                <div style={{ display: "flex", flexGrow: 1, width: "100%" }}>
                  {getFamilyMemberRows(
                    familyMemberInfo,
                    districtId,
                    regionId,
                    areaId,
                    clusterId,
                    zoneId,
                    chapterId,
                    onSelectMember
                  )}
                </div>
              </CardWithFooter>
              <CardWithFooter
                onViewMoreHandler={onViewMoreHandler}
                title="Subscription Details"
                minHeight={100}
                tableType={TABLE_TYPE.SUBS}
                disableViewMore={
                  subscriptionMemberInfo.length <= ROW_LIMIT.SUBS
                }
                customStyles={{
                  //   minWidth: "369px",
                  width: "85vw",
                  padding: "0px 10px 0px 10px",
                }}
                editSub
                action={toggleEditSub}
              >
                <EditSubscription
                  open={editSubscription}
                  onClose={toggleEditSub}
                  application={memberInfo}
                  onRefresh={onRefresh}
                />
                <NewTable
                  isSubscription
                  columns={SUBSCRIPTION_COL}
                  limit={ROW_LIMIT.SUBS}
                  rows={getSubscriptionRows(subscriptionMemberInfo)}
                  tableHeadCellStyle={styles.tableHeadCells}
                  tableBodyTheme="#E8EDF4"
                />
              </CardWithFooter>
              <Box>
                <CardWithFooter
                  onViewMoreHandler={onViewMoreHandler}
                  title="Special Group Induction/Graduation"
                  tableType={TABLE_TYPE.SPECIAL}
                  disableViewMore={
                    specialMemberInfo.length <= ROW_LIMIT.SPECIAL
                  }
                  minHeight={70}
                  customStyles={{
                    // minWidth: "369px",
                    width: "85vw",
                    padding: "0px 10px 0px 10px",
                  }}
                >
                  <NewTable
                    columns={SPECIAL_GROUP_COL}
                    limit={ROW_LIMIT.SPECIAL}
                    rows={getSpecialGroupRows(specialMemberInfo)}
                    tableHeadCellStyle={styles.tableHeadCells}
                    tableBodyTheme="#E8EDF4"
                  />
                </CardWithFooter>
                <CardWithFooter
                  title="Remarks"
                  minHeight={25}
                  icon={<Comment />}
                  hideFooter
                  customStyles={{
                    // minWidth: "369px",
                    width: "85vw",
                    padding: "0px 10px 0px 10px",
                  }}
                >
                  {!remark || !remark.length ? (
                    <div style={{ margin: "auto", textAlign: "center" }}>
                      <Typography
                        weight={600}
                        style={{
                          variant: "small",
                          color: "#000000",
                          padding: "4px",
                        }}
                      >
                        No data available
                      </Typography>
                    </div>
                  ) : (
                    <Box style={styles.remark}>
                      <Typography style={styles.remarksStyle}>
                        {remark}
                      </Typography>
                    </Box>
                  )}
                </CardWithFooter>
              </Box>
            </Box>

            {/* Examination Details Row */}

            <Box
              style={{
                ...styles.cardContainerMobile,
                // flexGrow: 1,
                height: "600px",
              }}
            >
              <CardWithFooter
                onViewMoreHandler={onViewMoreHandler}
                title="Examination Details"
                minHeight={100}
                tableType={TABLE_TYPE.EXAMINATION}
                disableViewMore={examMemberInfo.length <= ROW_LIMIT.EXAMINATION}
                customStyles={{
                  //   minWidth: "400px",
                  width: "85vw",
                }}
                mainContainerStyle={styles.appointment}
                icon={<Notes />}
                action={toggleDirectExamEntry}
                showExamButton
              >
                <DirectExamEntryModal
                  open={directExamEntryModal}
                  onClose={toggleDirectExamEntry}
                  application={memberInfo}
                  onRefresh={onRefresh}
                />
                <NewTable
                  columns={EXAMINATION_COL}
                  limit={ROW_LIMIT.EXAMINATION}
                  rows={getExamRows(
                    examMemberInfo,
                    hasPermission,
                    handleDeleteClick,
                    onEditClick
                  )}
                  tableHeadCellStyle={styles.tableHeadCells}
                  tableBodyTheme="#F6F6F6"
                />
              </CardWithFooter>
              <CardWithFooter
                onViewMoreHandler={onViewMoreHandler}
                title="Awards"
                minHeight={100}
                tableType={TABLE_TYPE.AWARDS}
                disableViewMore={awardMemberInfo.length <= ROW_LIMIT.AWARDS}
                customStyles={{
                  //   minWidth: "400px",
                  width: "85vw",
                }}
                mainContainerStyle={styles.appointment}
                icon={<Awards />}
              >
                <NewTable
                  columns={AWARDS_COL}
                  limit={ROW_LIMIT.AWARDS}
                  rows={getAwardRows(awardMemberInfo)}
                  tableHeadCellStyle={styles.tableHeadCells}
                  tableBodyTheme="#F6F6F6"
                />
              </CardWithFooter>

              <CardWithFooter
                onViewMoreHandler={onViewMoreHandler}
                title="Gohonzon Details"
                minHeight={100}
                tableType={TABLE_TYPE.GOHONZON}
                disableViewMore={
                  gohonzonMemberInfo.length <= ROW_LIMIT.GOHONZON
                }
                subTitle="Gohonzon Details"
                customStyles={{
                  //   minWidth: "306px",
                  width: "85vw",
                }}
                mainContainerStyle={styles.appointment}
                action={toggleDirectEntry}
                showButton
                // hideFooter
              >
                <DirectEntryModal
                  open={directEntryModal}
                  onClose={toggleDirectEntry}
                  application={memberInfo}
                  onRefresh={onRefresh}
                />
                <NewTable
                  columns={GOHONZON_COL}
                  rows={getGohonzonMemberRows(gohonzonMemberInfo)}
                  tableHeadCellStyle={styles.tableHeadCells}
                  tableBodyTheme="#F6F6F6"
                />
              </CardWithFooter>
            </Box>

            {/* Appointments Details Row */}

            <Box
              style={{
                ...styles.cardContainer,
                flexDirection: "column",
              }}
            >
              <CardWithFooter
                onViewMoreHandler={onViewMoreHandler}
                mainContainerStyle={styles.appointment}
                title="Appointments"
                minHeight={100}
                tableType={TABLE_TYPE.APPOINTMENT}
                disableViewMore={appointmentInfo.length <= 0}
                subTitle="Current Appointment"
                customStyles={{
                  width: "85vw",
                }}
              >
                <NewTable
                  columns={APPOINTMENT_COL}
                  tableBodyTheme="#F6F6F6"
                  rows={getAppointmentRows(appointmentInfo)}
                  tableHeadCellStyle={styles.tableHeadCells}
                />
              </CardWithFooter>
              <CardWithFooter
                mainContainerStyle={styles.appointment}
                onViewMoreHandler={onViewMoreHandler}
                tableType={TABLE_TYPE.PREVIOUSAPPOINTMENT}
                disableViewMore={previousAppointmentInfo.length <= 0}
                customStyles={{
                  width: "85vw",
                }}
                subTitle="Previous Appointment"
                footerText="View History"
              >
                <Box>
                  <NewTable
                    columns={PREVIOUS_APPOINTMENT_COL}
                    tableBodyTheme="#F6F6F6"
                    rows={getPreviousAppointmentRows(previousAppointmentInfo)}
                    tableHeadCellStyle={styles.tableHeadCells}
                  />
                </Box>
              </CardWithFooter>
              <Box mt={2} />
            </Box>

            {/* HDC details  */}

            <Box
              style={{
                ...styles.cardContainer,
                flexDirection: "column",
              }}
            >
              <CardWithFooter
                onViewMoreHandler={onViewMoreHandler}
                mainContainerStyle={styles.appointment}
                title="Honorary District Chief"
                minHeight={100}
                tableType={TABLE_TYPE.HDC}
                disableViewMore={hdcInfo?.length <= ROW_LIMIT.HDC}
                customStyles={{
                  width: "85vw",
                }}
              >
                <NewTable
                  columns={HDC_COL}
                  tableBodyTheme="#F6F6F6"
                  rows={getHdcRows(hdcInfo)}
                  tableHeadCellStyle={styles.tableHeadCells}
                />
              </CardWithFooter>

              <Box mt={2} />
            </Box>

            {/* Attendance Details Tables */}

            <Box>
              <Box style={styles.cardContainerMobile}>
                <CardWithFooter
                  onViewMoreHandler={onViewMoreHandler}
                  title="Attendance"
                  mixHeight={210}
                  mainContainerStyle={styles.attandenceMobile}
                  customStyles={{ width: "85vw" }}
                  tableType={TABLE_TYPE.ATTENDANCE}
                  disableViewMore={
                    getMaxRow(attendanceInfo) <= ROW_LIMIT.ATTENDANCE
                  }
                  dropDown={
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        width: "100%",
                      }}
                    >
                      <div style={{ width: "30%" }}>
                        <Dropdown
                          label="Select Meeting Type"
                          name={meetingType}
                          options={MEETING_TYPE}
                          value={meetingType}
                          onChange={(e) => {
                            setMeetingType(e.target.value);
                          }}
                        />
                      </div>

                      <div
                        style={{
                          display: "flex",
                          marginLeft: "auto",
                          width: "30%",
                        }}
                      >
                        <Dropdown
                          label="Select Meeting Type"
                          name={meetingType1}
                          options={MEETING_TYPE}
                          value={meetingType1}
                          onChange={(e) => {
                            setMeetingType1(e.target.value);
                          }}
                        />
                      </div>
                      <div
                        style={{
                          display: "flex",
                          marginLeft: "auto",
                          marginRight: "2.2%",
                          width: "30%",
                        }}
                      >
                        <Dropdown
                          label="Select Meeting Type"
                          name={meetingType2}
                          options={MEETING_TYPE}
                          value={meetingType2}
                          onChange={(e) => {
                            setMeetingType2(e.target.value);
                          }}
                        />
                      </div>
                    </div>
                  }
                >
                  <AttendanceTabel
                    meeting={
                      meetingType === "goshoMeeting"
                        ? goshoMeeting
                        : meetingType === "NHRMeeting"
                        ? NHRMeeting
                        : meetingType === "cubMeeting"
                        ? cubMeeting
                        : meetingType === "SDMeeting"
                        ? SDMeeting
                        : meetingType === "YPMeeting"
                        ? YPMeeting
                        : meetingType === "YLMeeting"
                        ? YLMeeting
                        : discussionMeeting
                    }
                    table1
                  />
                  <AttendanceTabel
                    meeting={
                      meetingType1 === "discussionMeeting"
                        ? discussionMeeting
                        : meetingType1 === "NHRMeeting"
                        ? NHRMeeting
                        : meetingType1 === "cubMeeting"
                        ? cubMeeting
                        : meetingType1 === "SDMeeting"
                        ? SDMeeting
                        : meetingType1 === "YPMeeting"
                        ? YPMeeting
                        : meetingType1 === "YLMeeting"
                        ? YLMeeting
                        : goshoMeeting
                    }
                    table2
                  />
                  <AttendanceTabel
                    meeting={
                      meetingType2 === "goshoMeeting"
                        ? goshoMeeting
                        : meetingType2 === "NHRMeeting"
                        ? NHRMeeting
                        : meetingType2 === "cubMeeting"
                        ? cubMeeting
                        : meetingType2 === "SDMeeting"
                        ? SDMeeting
                        : meetingType2 === "YPMeeting"
                        ? YPMeeting
                        : meetingType2 === "YLMeeting"
                        ? YLMeeting
                        : discussionMeeting
                    }
                  />
                </CardWithFooter>
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>
      <Modal open={openModal} onClose={toggleModal} customStyle={styles.modal}>
        <ModalContent
          memberId={memberId}
          modalTitle={modalTitle}
          subTitle={modalSubTitle}
          selectedTable={selectedTable}
          meetingType={meetingType}
          meetingType1={meetingType1}
          meetingType2={meetingType2}
          onRefresh={onRefresh}
        />
      </Modal>
      {/* {isLoading && <Loader />} */}
      <UpdateDirectExamEntryModal
        open={updateExamEntryModal}
        onClose={() => toggleUpdateExamEntry()}
        exam={selectedExam}
        onRefresh={onRefresh}
      />
      <Alert
        open={openAlert}
        onClose={toggleAlert}
        onSubmit={onDeleteClick}
        selectedMember={selectedMember}
      />
    </>
  );
}

export default DashboardForMobile;
